import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { VoucherStatus } from '@vi-iot/client';

import { AppState } from '../app.state';

import { VouchersState } from './vouchers.state';

export namespace VouchersSelectors {
  export const vouchersState = (state: AppState): VouchersState => state.vouchers;

  export function getState(): MemoizedSelector<
    AppState,
    VouchersState,
    DefaultProjectorFn<VouchersState>
  > {
    return createSelector(vouchersState, (state: VouchersState) => state);
  }

  // GENERATING

  export function getIsGeneratingVoucher(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(vouchersState, (state: VouchersState) => state.generateVoucher.loading);
  }

  export function getAttemptedToGenerateVoucher(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(vouchersState, (state: VouchersState) => state.generateVoucher.loaded);
  }

  export function getVoucherGeneratedSuccessfully(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      vouchersState,
      (state: VouchersState) => !state.generateVoucher.error && state.generateVoucher.loaded
    );
  }

  export function getVoucher(): MemoizedSelector<AppState, string, DefaultProjectorFn<string>> {
    return createSelector(vouchersState, (state: VouchersState) => state.voucher);
  }

  // VALIDATING

  export function isValidatingVoucher(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(vouchersState, (state: VouchersState) => state.validateVoucher.loading);
  }

  export function getAttemptedToValidateVoucher(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(vouchersState, (state: VouchersState) => state.validateVoucher.loaded);
  }

  export function getVoucherValidatedSuccessfully(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      vouchersState,
      (state: VouchersState) => !state.validateVoucher.error && state.validateVoucher.loaded
    );
  }

  export function getIsVoucherAvailable(): MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > {
    return createSelector(
      vouchersState,
      (state: VouchersState) => state.voucherStatus === VoucherStatus.FreeToUse
    );
  }
}
